module.exports = __webpack_public_path__ + "static/media/logo.0f8eeefb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 181
// module chunks = 0